<template>
	<el-row class="filter-container">
		<!-- 维度选择 -->
		<el-select v-model="dimensionValue" placeholder="请选择维度">
			<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
			</el-option>
		</el-select>
		<!-- 时间选择 -->
		<el-date-picker v-model="datePickerValue" :type="datePickerType" :placeholder="datePickerPlaceholder"
			:value-format="dateValueFormat" @change="handleDateChange" :picker-options="pickerOptions">
		</el-date-picker>
		<!-- 功能按钮 -->
		<can-button label="地区选择" @buttonClick="openDialog" :permissions="['area_queryField_area']"></can-button>
		<!-- <can-button label="指标选择" @buttonClick="openDialog" :permissions="['area_queryField_index']"></can-button> -->
		<can-button label="快递公司" @buttonClick="openDialog" :permissions="['area_queryField_com']"></can-button>
		<can-button label="批量关注" @buttonClick="handleMultiConcern" :permissions="['area_module']"
			:disabled="multiButton" v-if="!multiConcernHide"></can-button>
		<can-button label="下载所选数据" @buttonClick="downloadData" :permissions="['area_opt_downloda']">
		</can-button>


		<!-- 模态框 -->
		<el-dialog custom-class="filter-dialog" :visible.sync="dialogVisible">
			<div class="dialog-header" slot="title">
				<span class="dialog-title">筛选</span>
				<el-radio-group @change="dialogRadioChange" class="dialog-radio" v-model="filterRadio" size="medium">
					<el-radio-button label="地区选择"></el-radio-button>
					<!-- <el-radio-button label="指标选择"></el-radio-button> -->
					<el-radio-button label="快递公司"></el-radio-button>
				</el-radio-group>
				<el-input v-if="filterRadio!=='指标选择'" placeholder="搜索" suffix-icon="el-icon-search"
					v-model="filterText">
				</el-input>
			</div>
			<div class="dialog-body">
				<!-- 地区选择内容 -->
				<div v-if="filterRadio=='地区选择'">
					<el-alert show-icon title="最多选择5个地区" type="info" :closable="false">
					</el-alert>
					<el-tree ref="areaTree" show-checkbox :data="locationData" :props="defaultProps" node-key="value"
						:filter-node-method="filterNode" @check="treeCheckChange">
					</el-tree>
				</div>

				<!-- 指标选择内容 -->
				<div v-else-if="filterRadio=='指标选择'" class="index-container">
					<!-- <div class="input-container">
							<div class="input-item">
								<span class="item-title">妥投率（%）：</span>
								<el-input type="number" v-model="indexData.signRateStart"></el-input>
								<span class="item-line">——</span>
								<el-input type="number" v-model="indexData.signRateEnd"></el-input>
								<i class="el-icon-refresh-right"></i>
							</div>
							<div class="input-item">
								<span class="item-title">妥投率环比增长（%）：</span>
								<el-input type="number" v-model="indexData.signRateSgStart"></el-input>
								<span class="item-line">——</span>
								<el-input type="number" v-model="indexData.signRateSgEnd"></el-input>
								<i class="el-icon-refresh-right"></i>
							</div>
							<div class="input-item">
								<span class="item-title">退签率（%）：</span>
								<el-input type="number" v-model="indexData.returnRateStart"></el-input>
								<span class="item-line">——</span>
								<el-input type="number" v-model="indexData.returnRateEnd"></el-input>
								<i class="el-icon-refresh-right"></i>
							</div>
							<div class="input-item">
								<span class="item-title">退签率环比增长（%）：</span>
								<el-input type="number" v-model="indexData.returnRateSgStart"></el-input>
								<span class="item-line">——</span>
								<el-input type="number" v-model="indexData.returnRateSgEnd"></el-input>
								<i class="el-icon-refresh-right"></i>
							</div>
						</div> -->
					<div class="check-container">
						<check-group title="揽件情况" :check-group-list="indexData.solicitationList" type="solicitation"
							:checked-list="indexData.checkedSolicitationList" @checkedChange="handleCheckGroudChange">
						</check-group>
						<check-group title="派件情况" :check-group-list="indexData.deliveryList" type="delivery"
							:checked-list="indexData.checkedDeliveryList" @checkedChange="handleCheckGroudChange">
						</check-group>
					</div>
				</div>
				<!-- 快递公司选择内容 -->
				<div v-else class="com-container">
					<check-group title="自营" :check-group-list="comData.autarkyList" type="autarky"
						:checked-list="comData.checkedAutarkyList" @checkedChange="handleCheckGroudChange">
					</check-group>
					<check-group title="加盟" :check-group-list="comData.participateList" type="participate"
						:checked-list="comData.checkedParticipateList" @checkedChange="handleCheckGroudChange">
					</check-group>
					<div class="nodata" v-if="comData.autarkyList.length==0&&comData.participateList.length==0">
						<img src="https://cdn.kuaidi100.com/images/openApiWeb/common/none.png" alt="">
						<p>请换个关键词再试一试</p>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<div class="footer-key">
					<el-checkbox v-if="filterRadio=='快递公司'" v-model="allChecked" @change="handleAllChecked">全选
					</el-checkbox>
					<el-link v-else :underline="false" @click="resetAllCheck"><i class="el-icon-refresh-right
					"></i>重置</el-link>
				</div>
				<div v-if="filterRadio=='地区选择'&&checkNodes.length>0" class="footer-text">
					{{statisticsText}}<span>总计{{checkNodes.length}}个</span>
				</div>
				<div class="button-container">
					<el-button @click="closeDialog(true)">取 消</el-button>
					<el-button type="primary" @click="closeDialog(false)">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</el-row>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import CheckGroup from '@/components/CheckGroup/index.vue'
	import CanButton from '@/components/CanButton/index.vue'
	// import {
	// 	downLoadAreaInfo,
	// } from '@/utils/api/com'
	import {
		formatTime,
		downloadFile,
		httpBuildQuery
	} from '@/utils/common'
	export default {
		components: {
			CheckGroup,
			CanButton
		},
		props: ['multiButton', 'downloadUrl'],
		data() {
			// 地区信息（省级禁止选择）
			const locationData = window.locationData?window.locationData.map(item => {
				item.disabled = true
				return item
			}):[]
			const lastMonthDate = new Date(new Date().setMonth(new Date().getMonth() - 1))
			const defaultDatePickerValue = formatTime('YYYYmm', lastMonthDate)
			return {
				filterText: '',
				dimensionValue: 'month',
				pickerOptions: {
					// 202104开始至当前月的上个月为止
					disabledDate(time) {
						const beginTimer = new Date('2021-04-01')
						const endTimer = lastMonthDate
						return time.getTime() > endTimer || beginTimer.getTime() > time.getTime();
					},
				},
				datePickerValue: defaultDatePickerValue,
				datePickerType: 'month',
				datePickerPlaceholder: '请选择月',
				dateValueFormat: 'yyyyMM',
				options: [
					// 	{
					// 	value: 'date',
					// 	label: '日'
					// }, 
					{
						value: 'month',
						label: '月'
					},
					// {
					// 	value: 'year',
					// 	label: '年'
					// }, 
				],
				filterRadio: '地区选择',
				dialogVisible: false,
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				indexData: {
					signRateStart: undefined,
					signRateEnd: undefined,
					signRateSgStart: undefined,
					signRateSgEnd: undefined,
					returnRateStart: undefined,
					returnRateEnd: undefined,
					returnRateSgStart: undefined,
					returnRateSgEnd: undefined,
					solicitationList: [{
						code: '正常',
						name: '正常'
					}, {
						code: '异常',
						name: '异常'
					}],
					deliveryList: [{
						code: '正常',
						name: '正常'
					}, {
						code: '异常',
						name: '异常'
					}],
					checkedSolicitationList: [],
					checkedDeliveryList: [],
				},
				comData: {
					autarkyList: [],
					participateList: [],
					checkedAutarkyList: [],
					checkedParticipateList: []
				},

				locationData: locationData,
				allChecked: false,
				checkNodes: [],
				statisticsText: '',
				cityNodes: [],
			}
		},
		computed: {
			...mapGetters([
				'autarkyList',
				'participateList',
			]),
			multiConcernHide() {
				return this.$route.path.includes('concern')
			}
		},
		watch: {
			autarkyList(val) {
				this.comData.autarkyList = val||[]
			},
			participateList(val) {
				this.comData.participateList = val||[]
			},
			dimensionValue(val) {
				this.datePickerType = val
				this.datePickerPlaceholder = `请选择${this.options.find(item=>item.value==val).label}`
				this.dateValueFormat = val == 'month' ? 'yyyyMM' : val == 'date' ? 'yyyyMMdd' : 'yyyy'
			},
			filterText(val) {
				if (this.filterRadio == '地区选择') {
					this.$refs.areaTree.filter(val);
				} else {
					this.comData.autarkyList = this.autarkyList.filter(item => item.name.includes(val))
					this.comData.participateList = this.participateList.filter(item => item.name.includes(val))
				}
			},
			checkNodes(val) {
				if (val.length > 0) {
					let statisticsText = '已选'
					val.forEach((item, i) => {
						statisticsText += item.label + (i == val.length - 1 ? ' ' : '、')
					})
					this.statisticsText = statisticsText;
				} else {
					this.statisticsText = ''
				}

				const cityNodes = Array.from(new Set(val.map(item => item.level == 2 ? item.value : item.pcode)))
				if (cityNodes.length !== this.cityNodes.length) {
					this.locationData.forEach(item => {
						item.children && item.children.forEach(city => {
							let disabled = cityNodes.length == 5 && !cityNodes.includes(city.value)
							this.$set(city, "disabled", disabled)
							city.children && city.children.forEach(item => {
								this.$set(item, "disabled", disabled)
							})
						})
					})
				}

				this.cityNodes = cityNodes

			},
		},
		methods: {
			// 时间选择
			handleDateChange() {
				this.updateFilter()
			},
			// 打开模态框
			openDialog(label) {
				this.filterRadio = label
				this.dialogVisible = true
			},
			// 关闭模态框
			closeDialog(isInit) {
				if (!isInit) {
					this.updateFilter()
				}
				this.filterText = ''
				this.dialogVisible = false
			},
			// 模态框上层类型切换
			dialogRadioChange(label) {
				this.filterText = ''
				if (label == '地区选择') {
					this.$refs.areaTree.setCheckedNodes([...this.checkNodes])
				}
			},

			// 地区节点选择
			treeCheckChange() {
				this.checkNodes = this.$refs.areaTree.getCheckedNodes()
			},
			// 地区过滤
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			// 地区全选（暂不启用）
			handleAreaAllChecked() {
				if (this.allChecked) {
					const checkNodes = [...this.locationData, ...this.locationData.filter(item => item.label == '香港')[0]
						.children
					]
					//全选
					this.$refs.areaTree.setCheckedNodes(checkNodes);
				} else {
					//取消选中
					this.$refs.areaTree.setCheckedKeys([]);
				}
			},
			// 快递公司全选
			handleComAllChecked() {
				this.comData.checkedAutarkyList = this.allChecked ? this.comData.autarkyList.map(item => item.code) : []
				this.comData.checkedParticipateList = this.allChecked ? this.comData.participateList.map(item => item
					.code) : []
			},
			// 底部全选点击
			handleAllChecked() {
				if (this.filterRadio == '地区选择') {
					// this.handleAreaAllChecked()
				} else {
					this.handleComAllChecked()
				}
			},
			// 多选框选择（组件type）
			handleCheckGroudChange(checked, type) {
				switch (type) {
					case 'solicitation':
						this.indexData.checkedSolicitationList = checked
						break;
					case 'delivery':
						this.indexData.checkedDeliveryList = checked
						break;
					case 'autarky':
						this.comData.checkedAutarkyList = checked
						break;
					case 'participate':
						this.comData.checkedParticipateList = checked
						break;
					default:
						break;
				}
			},
			// 重置选择（地区选择和指标）
			resetAllCheck() {
				if (this.filterRadio == '地区选择') {
					this.$refs.areaTree.setCheckedKeys([]);
					this.checkNodes = []
				} else {
					this.indexData.checkedSolicitationList = []
					this.indexData.checkedDeliveryList = []
				}
			},
			createFilter() {
				return {
					com: [...this.comData.checkedAutarkyList, ...this.comData.checkedParticipateList],
					from: [...this.checkNodes.map(item => item.fullname)],
					dataTime: this.datePickerValue,
					page: 1
				}
			},
			// 更新列表
			updateFilter() {
				this.$store.dispatch('com/setAreaTableFilter', this.createFilter())
			},
			// 批量关注
			handleMultiConcern() {
				this.$emit('handleMultiConcern')
			},
			// 下载所选数据
			downloadData() {
				downloadFile(this.downloadUrl + httpBuildQuery(this.createFilter()))
			}
		}
	}
</script>

<style lang="less">
	.filter-container {

		>div,
		button {
			margin-bottom: 20px;
			margin-right: 10px;
		}

		.filter-dialog {
			width: 60%;
			min-width: 720px;
			padding: 0;

			.el-dialog__header {
				padding: 0;

				.dialog-header {
					padding: 20px 20px 10px;
					border-bottom: 1px solid #eee;
					display: flex;
					align-items: center;

					.dialog-title {
						position: absolute;
						height: 36px;
						line-height: 36px;
						font-size: 16px;
						font-weight: bold;
					}

					.dialog-radio {
						flex: 1;
						text-align: center;
					}

					.el-input {
						position: absolute;
						width: 20%;
						right: 45px;

						.el-input__inner {
							height: 36px;
						}
					}
				}

				.el-dialog__headerbtn {
					top: 30px;
					right: 10px;
				}
			}

			.el-dialog__body {
				padding: 0;

				.dialog-body {
					padding: 20px;
					min-height: 50vh;
					max-height: 50vh;
					overflow: auto;

					.index-container {
						.input-container {
							display: flex;
							align-items: center;
							flex-wrap: wrap;
							justify-content: space-between;

							.input-item {
								display: flex;
								align-items: center;
								box-sizing: border-box;

								padding: 5px 10px;
								border-radius: 4px;

								&:hover {
									background-color: #D1E9FF;

									i {
										opacity: 1;
									}
								}

								.item-title {
									width: 160px;
								}

								.el-input {
									width: 120px;
								}

								.item-line {
									margin: 0 5px;
								}

								i {
									font-size: 20px;
									opacity: 0;
									margin-left: 15px;
								}
							}
						}
					}

					.nodata {
						text-align: center;
						padding-top: 57px;
					}
				}
			}

			.el-dialog__footer {
				padding: 0;

				.dialog-footer {
					padding: 10px 20px;
					border-top: 1px solid #eee;
					display: flex;
					align-items: center;
					justify-content: space-between;

					.footer-key {
						float: left;
					}

					.footer-text {
						font-size: 14px;
						color: #606266;
						flex: 1;
						margin: 0 10px;
						text-align: left;

						>span {
							font-weight: bold;
						}
					}
				}

			}
		}

	}
</style>
